import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { FinancialDocumentRow } from 'src/features/financialDocumentRows/utils/types';
import DeleteFinancialDocumentRowFormModal from 'src/features/financialDocumentRows/components/forms/DeleteFinancialDocumentRowFormModal';
import UpdateFinancialDocumentRowFormModal from 'src/features/financialDocumentRows/components/forms/UpdateFinancialDocumentRowFormModal';
import { financialDocumentRowMessages } from 'src/features/financialDocumentRows/utils/messages';
import { FINANCIAL_DOCUMENT_STATUS } from 'src/features/financialDocuments/utils/types';

type CellFinancialDocumentRowActions = {
    row: Row<FinancialDocumentRow>;
    financialDocumentStatus?: FINANCIAL_DOCUMENT_STATUS;
};

export default function CellFinancialDocumentRowActions({
    financialDocumentStatus,
    row,
}: CellFinancialDocumentRowActions) {
    const { formatMessage } = useIntl();

    if (!financialDocumentStatus || financialDocumentStatus !== FINANCIAL_DOCUMENT_STATUS.DRAFT) return null;

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateFinancialDocumentRowFormModal
                        semantics={{ entryName: formatMessage(financialDocumentRowMessages.row).toLowerCase() }}
                        selectedDocumentRow={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateFinancialDocumentRowFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteFinancialDocumentRowFormModal selectedDocumentRow={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteFinancialDocumentRowFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
